<template>
    <div class="mb-4 pr-4">      
        <div class="association-logo" :style="{'background-image':'url('+(logo)+')'}"></div>      
    </div>
</template>

<script>
import firebase from '@/firebase.js';

export default {
    props:['associationKey'],
    data() {
        return {
            logo:this.$store.state.associations[this.associationKey].logoUrl || ''
        }
    },

    created() {
        firebase.storage().ref('/associations/'+this.associationKey+'/logo.png').getDownloadURL().then(url=>{
            this.logo = url;
        });
    },
}
</script>

<style>
    .association-logo {
        padding-top: 50%;
        width: 100%;
        background-position: 50%;
        background-size: contain;
    }
</style>
